import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";
import { Reveal } from "./Reveal";
import { IMG } from "../lib/config";

export const CTASection = ({
  title = "¿Damos el primer paso juntos?",
  text = "Reserva tu primera cita de valoración. Un espacio seguro, confidencial y sin juicios para empezar a sentirte mejor.",
  testId = "cta-section",
}) => (
  <section data-testid={testId} className="relative overflow-hidden">
    <div className="absolute inset-0">
      <img src={IMG.cta} alt="" loading="lazy" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-ink/55" />
    </div>
    <div className="relative mx-auto max-w-4xl px-6 py-28 text-center md:py-36">
      <Reveal>
        <p className="overline text-sand">Primera cita</p>
        <h2 className="mt-5 font-serif text-4xl font-light leading-tight text-bg-primary md:text-6xl">{title}</h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-bg-primary/80 md:text-lg">{text}</p>
        <Link
          to="/contacto"
          data-testid={`${testId}-button`}
          className="mt-10 inline-flex items-center gap-2 rounded-full bg-bg-primary px-8 py-4 text-sm font-medium text-ink transition-transform duration-300 hover:scale-[1.03]"
        >
          Pide tu primera cita <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
        </Link>
      </Reveal>
    </div>
  </section>
);

export const Marquee = ({ words = ["Calma", "Bienestar", "Equilibrio", "Empatía", "Presencia", "Confianza"] }) => {
  const loop = [...words, ...words];
  return (
    <section className="overflow-hidden border-y border-ink/5 bg-bg-sage py-10" aria-hidden="true">
      <div className="marquee-track">
        {loop.map((w, i) => (
          <span key={i} className="mx-12 font-serif text-5xl font-light text-sage-dark md:text-7xl">
            {w} <span className="text-sand">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};

export const FAQ = ({ faqs, testId = "faq" }) => (
  <div data-testid={testId} className="mx-auto max-w-3xl">
    <Accordion type="single" collapsible className="w-full">
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-b border-ink/10">
          <AccordionTrigger data-testid={`${testId}-trigger-${i}`} className="py-6 text-left font-serif text-xl font-normal text-ink hover:no-underline">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="pb-6 text-base leading-relaxed text-ink-soft">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
);
